import { render, staticRenderFns } from "./TriggerTemplate.vue?vue&type=template&id=07b85a40&scoped=true&"
import script from "./TriggerTemplate.vue?vue&type=script&lang=js&"
export * from "./TriggerTemplate.vue?vue&type=script&lang=js&"
import style0 from "./TriggerTemplate.vue?vue&type=style&index=0&id=07b85a40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b85a40",
  null
  
)

export default component.exports